function MenuSection({
  menus,
  onHandleClickMenu,
  isMenuOpen,
  setIsMenuOpen,
  selectedPage,
}) {
  return (
    <div
      className={`flex flex-col lg:flex-row gap-7 fixed lg:static top-0 left-0 h-full w-full lg:w-auto bg-white lg:bg-transparent z-20 lg:z-auto transform ${
        isMenuOpen ? "translate-x-0" : "-translate-x-full"
      } transition-transform duration-300 lg:transition-none justify-center lg:justify-center`}
    >
      <div className="flex flex-col lg:flex-row gap-7 items-center py-10 lg:py-0 lg:flex-grow justify-center">
        {menus.map((menu, index) => (
          <div
            key={index}
            onClick={() => {
              onHandleClickMenu(menu);
              setIsMenuOpen(false);
            }}
            className={`cursor-pointer px-3 py-2 text-lg lg:text-base ${
              selectedPage.name === menu.name ? "text-hijau" : "text-black"
            }`}
          >
            {menu.name}
          </div>
        ))}
      </div>
    </div>
  );
}

export default MenuSection;
